import React from 'react';

export const SidebarData = [
 {
    title: 'Home',
    path: '/home',
    icon: <img src='/icon-home.svg' alt='Home'/>,
    cName: 'nav-text'
  },{
    title: 'Medición',
    path: '/medicion',
    icon: <img src='/icon-measurements.svg' alt='Medicion'/>,
    cName: 'nav-text'
  },{
    title: 'Reducción',
    path: '/reduccion',
    icon: <img src='/icon-reduction.svg' alt='Reduction'/>,
    cName: 'nav-text'
  },{
    title: 'Compensación',
    path: '/compensacion',
    icon: <img src='/icon-compensation.svg' alt='Compesation'/>,
    cName: 'nav-text'
  },{
    title: 'Contacto',
    path: '/contacto',
    icon: <img src='/icon-contact.svg' alt='Contacto'/>,
    cName: 'nav-text'
  }/*,{
    title: 'Salir',
    path: '/',
    icon: <FaIcons.FaSignOutAlt />,
    cName: 'nav-text'
  }*/

];


